
<div class="container p-0 m-0" style="overflow: hidden;">
  
    <!-- <div class="col-md-12 p-0 m-0 header-class" >
        <h3 class="header-title">We'd love your feedback</h3>
        </div> -->

        <div class="col-md-12 p-2 m-0 header-class" style="display: flex;justify-content: space-between;align-items: center;" >
            <h3 class="header-title">Select Language</h3>
            <img (click)="closeDialog()" height="13px" style="margin-right: 13px !important;" class="close_popup cursor-pointer text-center" src="../../../assets/svg/feedback/close.svg"/>
        </div>

        <div class="row" >
            <div class="col-sm-6">
                <ul class="language-list">
                    <li *ngFor="let language of languages"  (click)="selectLanguage(language)"  [style.color]="selectedLanguage === language ? '#f44336' : 'black'">{{ language }}</li>
                </ul>
            </div>
            <div class="col-md-12 ml-0 pl-0">
                <div class="d-flex titlemargin  titleMobile ml-0 pl-0" >
                   
                  

                </div>
                <!-- <mat-slider class="siderClass" style="width: 100% !important;"
                 [ngClass]="{bad: sliderValue == 1,poor:sliderValue == 2,normal:sliderValue == 3,good:sliderValue == 4,best:sliderValue == 5}" max="5" min="1"   [(ngModel)]="sliderValue" step="1" aria-label="unit(s)"></mat-slider> -->
            </div>

            <!-- <div class="col-md-12 mt-2">
                <span class="lable-style">Do you have any additional comments?</span>
            </div> -->
            <!-- <div class="col-md-12 mt-2" *ngIf="isLargeDevice">
                <textarea [(ngModel)]="feedbacktext" placeholder="Please enter your comment here" rows="4" cols="54" style="height: 70px;width: 94% !important;"></textarea>           
                 </div> -->
                 <!-- <div class="col-md-12 mt-2" *ngIf="isSmallDevice">
                    <textarea  style="height: 70px;width: 95% !important;margin-left: 0px;" [(ngModel)]="feedbacktext" placeholder="Please enter your comment here" rows="4" cols="42"></textarea>           
                     </div> -->

        </div>
    <div class="row ml-2 mr-2" mat-dialog-actions>
        <div  class="col-sm-12 text-center pt-1 pb-4">
            <!-- <button mat-flat-button class="action-btn dialog-btn cancel-button shadowClass action-btn-text w-100"
                (click)="closeDialog()">Cancel</button> -->
            <!-- <button mat-flat-button class="action-btn dialog-btn m-widht shadowClass action-btn-text feedback-submit"
                 translate="no">Submit</button> -->
        </div>
     
    </div>
</div>